import React, { ReactElement, ReactNode } from 'react'
import classNames from 'classnames'
import style from './index.module.scss'

interface IFooterSectionProps {
  children: ReactNode
  className?: string
}

export const FooterSection = ({
  children,
  className,
}: IFooterSectionProps): ReactElement => (
  <div className={classNames(style.FooterSection, className)}>{children}</div>
)
